export default "__VITE_ASSET__BlMK1SWn__"